module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921112334_T.2e3d06ac.jpg";